import styled from 'styled-components'
import React from 'react'
import IndexContentContainer from '../../index/IndexContentContainer'
import BookResponse from '../BookResponse'
import RowSpacer from '../../../common/styles/RowSpacer'
import BookRating from '../../../common/BookRating'
import BooksitoutImages from '../../../images/BooksitoutImages'
import { Author } from '../../../common/Author'

interface Props {
	book: BookResponse
	url?: string
    backgroundColor?: 'bg-card' | 'bg-card-card'
}

const BookMineDoneCard: React.FC<Props> = ({ book, url, backgroundColor }) => {
	const rs = book.readingSource

	return (
		<Container href={url ? url : `/book/mine/${book.id}`}>
			<IndexContentContainer className={`${backgroundColor != undefined ? backgroundColor : 'bg-card'} hover-effect`} marginBottom={0}>
				{rs && (
					<SourceBadgeWrapper>
						<SourceBadge>
							{rs.imageUrl && <SourceIcon src={rs.imageUrl} />}
							{rs.label}
							{rs.memo && <SourceTooltip>{rs.memo}</SourceTooltip>}
						</SourceBadge>
					</SourceBadgeWrapper>
				)}
				<ContentContainer>
                    <div>
					    <Cover src={book.cover != '' && book.cover != null ? book.cover : BooksitoutImages.Placeholder.bookCover} />
                    </div>

					<RowSpacer size={12.5} />

					<Title>{book.title}</Title>
					<RowSpacer size={2.5} />

					<Author>{book.author}</Author>

                    <span className={'d-block d-xl-none'}><RowSpacer size={10.5} /></span>
                    <span className={'d-none d-xl-block'}><RowSpacer size={4.5} /></span>

					<BookRating rating={book.rating ?? 0} size={20} />

                    <span className={'d-block d-xl-none'}><RowSpacer size={10.5} /></span>
                    <span className={'d-none d-xl-block'}><RowSpacer size={4.5} /></span>
				</ContentContainer>
			</IndexContentContainer>
		</Container>
	)
}

const Container = styled.a`
    padding-left: 2px;
    padding-right: 2px;

    height: 300px;
`

const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
	width: 100%;
`

const Cover = styled.img.attrs({
	className: 'img-fluid',
})`
	max-height: 150px;
	min-height: 150px;
	width: auto;
	max-width: 100%;
	object-fit: contain;
    border-radius: 10px;
`

const Title = styled.h1.attrs({
	className: 'clamp-1-line',
})`
	margin-top: 8px;
	font-size: 15px;
	text-align: center;
`

const SourceBadgeWrapper = styled.div`
	position: absolute;
	top: 6px;
	right: 6px;
	z-index: 5;
`

const SourceIcon = styled.img`
	width: 16px;
	height: 16px;
	border-radius: 4px;
`

const SourceBadge = styled.div`
	position: relative;
	display: inline-flex;
	align-items: center;
	gap: 4px;
	font-size: 11px;
	font-weight: 600;
	padding: 2px 8px;
	border-radius: 10px;
	background-color: var(--primary-color);
	color: white;
	white-space: nowrap;
`

const SourceTooltip = styled.div`
	display: none;
	position: absolute;
	top: calc(100% + 6px);
	right: 0;
	padding: 6px 10px;
	border-radius: 8px;
	background-color: var(--card-bg-color);
	color: var(--text-color);
	font-size: 12px;
	font-weight: 400;
	white-space: nowrap;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	z-index: 10;

	${SourceBadge}:hover & {
		display: block;
	}
`

export default BookMineDoneCard
